import React, { useEffect, useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import {
  Btn,
  DatePicker,
  formatDisplayDate,
  FormInput,
  SelectInput2,
  SuccessComp,
  toISODate,
} from "../../utils/utils";
import reqImg from "../../assets/req.png";
import { Add, Trash } from "iconsax-react";
import useEstates from "../../hooks/useEstates";
import { AxiosAuthGet, AxiosAuthPost } from "../../api/api";
import { useNavigate } from "react-router-dom";

const DevAddCus = () => {
  const navigate = useNavigate();
  const url = "developer/customers/";
  const [paymentType, setPaymentType] = useState("One-time");
  const [plotsSel, setPlotsSel] = useState([]);
  const [estId, setEstId] = useState("");
  const [estType, setEstType] = useState("");
  const estUrl = `developer/estates/${estType}/properties`;
  const { estatesArr } = useEstates();
  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(formatDisplayDate(today));
  const [firstPaymentDate, setFirstPaymentDate] = useState(
    formatDisplayDate(today),
  );
  const [months, setMonths] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");
  const [propType, setPropType] = useState("");
  const [propArr, setPropArr] = useState([]);
  const [selBlock, setSelBlock] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [singleBlock, setSingleBlock] = useState();
  const [
    ,
    // blockType
    setBlockType,
  ] = useState("");
  const estateType = estatesArr;
  const blocks = selBlock?.blocks;
  const [data, setData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    address: "",
    propertyId: "",
    numberOfUnits: 1,
    blockId: "",
    plots: [],
    paymentType: "",
    firstPaymentDate: "",
    paymentDate: "",
    monthlyPayments: "",
  });
  const [dataErr, setDataErr] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    address: "",
    propertyId: "",
    numberOfUnits: "",
    blockId: "",
    plots: [],
    paymentType: "",
    firstPaymentDate: "",
    paymentDate: "",
    monthlyPayments: "",
    installmentPayments: "",
  });

  const handlePropChange = (value) => {
    setPropType(value);
  };
  const getOpt = (opt) => {
    setSelBlock(opt);
  };
  const getBlk = (opt) => {
    setSingleBlock(opt);
  };

  const handleEstChange = (value) => {
    setEstType(value);
    setEstId(value);
  };
  const handleBlkChange = (value) => {
    setBlockType(value);
  };

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const getProp = () => {
    AxiosAuthGet(estUrl)
      .then((res) => {
        // console.log(res);
        setPropArr(res.data);
      })
      .catch((err) => {
        // console.log(err.response);
      });
  };

  useEffect(() => {
    getProp();
    // eslint-disable-next-line
  }, [estId]);
  useEffect(() => {
    setDataErr((prevErrs) => ({
      ...prevErrs,
      firstPaymentDate: "",
    }));
    // eslint-disable-next-line
  }, [date]);

  const selPlots = (item) => {
    // console.log(item);
    setPlotsSel((prev) => {
      const exists = prev.some((i) => i === item);

      return exists ? prev.filter((i) => i !== item) : [...prev, item];
    });
  };
  const addMonth = () => {
    if (data?.monthlyPayments === "" || toISODate(date) <= today) {
      setDataErr((prevErrs) => ({
        ...prevErrs,
        monthlyPayments:
          data?.monthlyPayments === "" && "This field cannot be empty",
        firstPaymentDate:
          data?.firstPaymentDate === "" &&
          "Installment date can't be today or a past date",
      }));
    } else {
      setMonths((prev) => {
        return [
          ...prev,
          {
            amount: Number(data?.monthlyPayments),
            dueDate: toISODate(date),
          },
        ];
      });
      setData((prev) => ({
        ...prev,
        monthlyPayments: "",
      }));
      setDate(formatDisplayDate(today));
    }
  };

  const rmMonth = (indexToRemove) => {
    setMonths((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const dataSet = {
    name: data.name,
    phoneNumber: data.phoneNumber,
    email: data.email,
    address: data.address,
    propertyId: propType,
    numberOfUnits: data.numberOfUnits,
    blockId: singleBlock?.id,
    plots: plotsSel,
    paymentType: paymentType,
    firstPaymentDate: toISODate(firstPaymentDate),
    installmentPayments: months,
  };

  const reqTotal = data?.numberOfUnits * selBlock?.pricePerUnit;
  const reqTotalLand = plotsSel?.length * singleBlock?.pricePerPlot;
  const totalAmount = months.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0,
  );

  const saveCustomer = () => {
    setIsLoading(true);
    AxiosAuthPost(url, dataSet)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res?.message);
        setData({
          name: "",
          phoneNumber: "",
          email: "",
          address: "",
          propertyId: "",
          numberOfUnits: 1,
          blockId: "",
          plots: [],
          paymentType: "",
          firstPaymentDate: "",
          monthlyPayments: "",
        });
        setPlotsSel([]);
        setPaymentType("One-time");

        setTimeout(() => {
          navigate("/dev_dash/customers");
          setSuccessMsg("");
        }, 2000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };

  return (
    <div>
      <SuccessComp message={successMsg} />
      <AgentHeader header={"Add Customers"} />
      <div className="estates_houses" style={{ margin: 0 }}>
        <div className="add_prop_inp">
          <h3>Customer Details</h3>
          <div className="flex_inp">
            <div className="each_flex_inp">
              <FormInput
                placeholder={"Full name"}
                label={"Name"}
                req={reqImg}
                id={"name"}
                changeInput={dataChange}
                value={data.name}
                err={dataErr.name}
              />
            </div>
            <div className="each_flex_inp">
              <FormInput
                placeholder={"081........."}
                label={"Phone Number"}
                req={reqImg}
                id={"phoneNumber"}
                changeInput={dataChange}
                value={data.phoneNumber}
                err={dataErr.phoneNumber}
              />
            </div>
          </div>
          <div className="flex_inp">
            <div className="each_flex_inp">
              <FormInput
                placeholder={"example@gmail.com"}
                label={"Email"}
                id={"email"}
                changeInput={dataChange}
                value={data.email}
                err={dataErr.email}
              />
            </div>
            <div className="each_flex_inp">
              <FormInput
                placeholder={"customer address"}
                label={"Address"}
                req={reqImg}
                id={"address"}
                changeInput={dataChange}
                value={data.address}
                err={dataErr.address}
              />
            </div>
          </div>
        </div>
        <div className="add_prop_inp">
          <h3>Property Information</h3>
          <div className="flex_inp">
            <SelectInput2
              options={estateType}
              onChange={handleEstChange}
              label={"Estate"}
              req={reqImg}
            />
            <SelectInput2
              options={propArr}
              onChange={handlePropChange}
              label={"Property"}
              req={reqImg}
              getItem={getOpt}
            />
          </div>
          {selBlock?.propertyType === "Building" && (
            <div className="each_flex_inp">
              <FormInput
                placeholder={"081........."}
                label={"Number of Units"}
                req={reqImg}
                id={"numberOfUnits"}
                type={"Number"}
                changeInput={dataChange}
                value={data.numberOfUnits}
                err={dataErr.numberOfUnits}
              />
            </div>
          )}
          {/* {selBlock?.propertyType === "LAnd" &&<div className="each_flex_inp">
              <FormInput
                placeholder={"081........."}
                label={"Number of Units"}
                req={reqImg}
                id={"numberOfUnits"}
                type={"Number"}
                changeInput={dataChange}
                value={data.numberOfUnits}
                err={dataErr.numberOfUnits}
              />
            </div>} */}
          {selBlock?.propertyType === "Land" && (
            <SelectInput2
              options={blocks}
              onChange={handleBlkChange}
              label={"Block"}
              getItem={getBlk}
              req={reqImg}
            />
          )}
          {selBlock?.propertyType === "Land" && (
            <div className="sel_plts">
              <p>
                Select Plots <span>(Multiple selection allowed)</span>
              </p>
              <div className="plts_arr">
                {singleBlock?.availablePlots?.map((item, idx) => {
                  return (
                    <Btn
                      key={idx}
                      btnClass={
                        plotsSel.includes(item)
                          ? "btn_dark_thin"
                          : "btn_dark_out_thin"
                      }
                      btnClick={() => selPlots(item)}
                      btnText={item}
                    />
                  );
                })}
              </div>
              <h5>
                {Number(singleBlock?.sizePerPlot)?.toLocaleString()} sqm per
                plot • ₦{singleBlock?.pricePerPlot?.toLocaleString()} per plot
              </h5>
            </div>
          )}
        </div>
        <div className="add_prop_inp">
          <h3>Payment</h3>
          <div className="paymentTypeContainer">
            <h4 className="paymentTypeTitle">Payment Type</h4>
            <label className="paymentOption">
              <input
                type="radio"
                name="paymentType"
                value="One-time"
                checked={paymentType === "One-time"}
                onChange={() => setPaymentType("One-time")}
              />
              <span className="customRadio"></span>
              One-time Payment
            </label>
            <label className="paymentOption">
              <input
                type="radio"
                name="paymentType"
                value="Installment"
                checked={paymentType === "Installment"}
                onChange={() => setPaymentType("Installment")}
              />
              <span className="customRadio"></span>
              Installment
            </label>
          </div>
          {paymentType === "One-time" && (
            <div className="pay_date">
              <div className="p_date">
                <h4>Payment Date</h4>
                <DatePicker
                  date={firstPaymentDate}
                  setDate={setFirstPaymentDate}
                />
                {/* <h6>February 5, 2025</h6> */}
              </div>
              <div className="p_date p_due">
                <h4>Payment Due</h4>
                <h6>{toISODate(firstPaymentDate)}</h6>
              </div>
            </div>
          )}
          {paymentType === "Installment" && (
            <div className="instal_pay">
              <div className="i_pay_head">
                <h3>Installment Payments</h3>
                {/* <Btn
                  btnClick={addMonth}
                  btnText={"Add Month"}
                  leftIcon={<Add size={16} color="#444444" />}
                  btnClass={"btn_dark_out_thin f_w_600"} 
                /> */}
              </div>
              <div className="months_div">
                {months.map((item, idx) => {
                  return (
                    <div key={idx} className="filled_blks">
                      <p>{`#${item?.amount.toLocaleString()}`}</p>
                      <Trash
                        color="#444444"
                        size={24}
                        onClick={() => rmMonth(idx)}
                        cursor={"pointer"}
                      />
                    </div>
                  );
                })}
                <div className="m_cont">
                  <p>Installment {months?.length + 1}</p>
                  <div className="m_input">
                    <FormInput
                      placeholder={"Amount"}
                      labelBg={"transparent"}
                      inputBg={{ padding: "10px" }}
                      type={"Number"}
                      id={"monthlyPayments"}
                      changeInput={dataChange}
                      value={data.monthlyPayments}
                      err={dataErr.monthlyPayments}
                    />
                  </div>
                  <div className="m_p_date">
                    <p>Payment Date</p>
                    <DatePicker date={date} setDate={setDate} />
                  </div>
                  <p style={{ fontFamily: "Work Sans", color: "red" }}>
                    {dataErr?.firstPaymentDate}
                  </p>
                </div>
              </div>
              <Btn
                btnClick={addMonth}
                btnText={"Add Installment"}
                leftIcon={<Add size={16} color="#444444" />}
                btnClass={"btn_dark_out_thin f_w_600"}
              />
              <div className="pay_sum">
                <div className="each_p_s">
                  <h5>Total Installmets</h5>
                  <p>{`#${totalAmount?.toLocaleString()}`}</p>
                </div>
                <div className="each_p_s">
                  <h5>Required Total</h5>
                  {selBlock?.propertyType === "Building" && (
                    <p className="nom_tot">{`#${reqTotal?.toLocaleString()}`}</p>
                  )}
                  {selBlock?.propertyType === "Land" && (
                    <p className="nom_tot">{`#${reqTotalLand?.toLocaleString()}`}</p>
                  )}
                </div>
              </div>
              <p style={{ fontFamily: "Work Sans", color: "red" }}>{dataErr?.installmentPayments}</p>
            </div>
          )}
        </div>
        <div className="est_btn">
          <Btn
            btnText={"Cancel"}
            btnClass={"home-btn_black-s"}
            btnClick={() => {}}
          />
          <Btn
            btnText={"Save Customer"}
            // disabled
            btnClass={"home-btn_s"}
            btnClick={saveCustomer}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default DevAddCus;
